module.exports = __webpack_public_path__ + "assets/4f3f0b4002b04cffcb89e25918c4f3c6.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/jlondon/Desktop/Work-Resize/roc2/engine/public-src/spingames/panel/sounds/buttons/autos/auto_100.mp3
 ** module id = 33
 ** module chunks = 0
 **/